module.exports = __webpack_public_path__ + "img/Add-Receiver.5c5c7230.svg";